const WORKER_ROLE_PLACEHOLDER = "arn:aws:iam::WORKER_AWS_ACCOUNT_ID:role/WORKER_ROLE_NAME";

const generateTrustPolicyStatement = (
  principal: string,
  tagAssumeRole: boolean,
  condition?: Record<string, Record<string, string>>
) => ({
  Version: "2012-10-17",
  Statement: [
    ...(tagAssumeRole
      ? [
          {
            Action: "sts:TagSession",
            Effect: "Allow",
            Principal: {
              AWS: principal,
            },
          },
        ]
      : []),
    {
      Action: "sts:AssumeRole",
      ...(condition && { Condition: condition }),
      Effect: "Allow",
      Principal: {
        AWS: principal,
      },
    },
  ],
});

export const generateExampleTrustPolicyStatement = (
  accountName: string,
  awsAccountId: string,
  tagAssumeRole: boolean
) =>
  generateTrustPolicyStatement(awsAccountId, tagAssumeRole, {
    StringLike: { "sts:ExternalId": `${accountName}@*` },
  });

export const generateWorkerTrustPolicyStatement = (externalId: string, tagAssumeRole: boolean) =>
  generateTrustPolicyStatement(
    WORKER_ROLE_PLACEHOLDER,
    tagAssumeRole,
    externalId ? { StringEquals: { "sts:ExternalId": externalId } } : undefined
  );
